import { Fragment, useEffect, useState } from "react";
import { m } from "framer-motion";

export const StarEmpty = () => {
    return (
        <img
            src="/assets/images/star-empty.png"
            alt="star-empty"
            className="object-contain w-full h-full mr-1"
        />
    );
};

export const StarHalf = ({ timeout, fx, duration = 0.2 }) => {
    const [showFilled, setShowFilled] = useState(false);

    useEffect(() => {
        const timeoutId = setTimeout(
            () => {
                if (fx) {
                    setShowFilled(true);
                }
            },
            timeout ? timeout : 100,
        );
        return () => {
            clearTimeout(timeoutId);
        };
    }, []);

    if (fx) {
        return (
            <Fragment>
                {showFilled && (
                    <m.img
                        initial={{
                            scale: 0,
                            opacity: 0,
                        }}
                        animate={{
                            scale: 1,
                            opacity: 1,
                        }}
                        transition={{
                            duration,
                            stiffness: 250,
                            type: "spring",
                        }}
                        src="/assets/images/star-half.png"
                        alt="star-half"
                        className="absolute top-0 left-0 object-contain w-full h-full mr-1"
                    />
                )}
                <img
                    src="/assets/images/star-empty.png"
                    alt="star-empty"
                    className="object-contain w-full h-full mr-1"
                />
            </Fragment>
        );
    } else {
        return (
            <img
                src="/assets/images/star-half.png"
                alt="star-half"
                className="object-contain w-full h-full mr-1"
            />
        );
    }
};

export const StarFull = ({ timeout, fx, duration = 0.2 }) => {
    const [showFilled, setShowFilled] = useState(false);

    useEffect(() => {
        const timeoutId = setTimeout(
            () => {
                if (fx) {
                    setShowFilled(true);
                }
            },
            timeout ? timeout : 100,
        );
        return () => {
            clearTimeout(timeoutId);
        };
    }, []);

    if (fx) {
        return (
            <Fragment>
                {showFilled && (
                    <m.img
                        initial={{
                            scale: 0,
                            opacity: 0,
                        }}
                        animate={{
                            scale: 1,
                            opacity: 1,
                        }}
                        transition={{
                            duration,
                            stiffness: 250,
                            type: "spring",
                        }}
                        src="/assets/images/star-full.png"
                        alt="star-full"
                        className="absolute top-0 left-0 object-contain w-full h-full mr-1"
                    />
                )}
                <img
                    src="/assets/images/star-empty.png"
                    alt="star-empty"
                    className="object-contain w-full h-full mr-1"
                />
            </Fragment>
        );
    } else {
        return (
            <img
                src="/assets/images/star-full.png"
                alt="star-full"
                className="object-contain w-full h-full mr-1"
            />
        );
    }
};

interface CollectionStarsProps {
    fx?: boolean;
    stars?: number;
    className?: string;
    timeoutStart?: number;
    fxDuration?: number;
}

export const CollectionStars: React.FC<CollectionStarsProps> = ({
    stars = 0,
    fx = false,
    className = "",
    timeoutStart = 1000,
    fxDuration = 200,
}) => {
    const getCollectionStars = (stars: number) => {
        let starIndex = 0;
        const starItems = [];
        let starItem;
        while (starIndex < 5) {
            if (stars > starIndex && stars < starIndex + 1) {
                starItem = (
                    <StarHalf
                        key={`star_${starIndex}`}
                        fx={fx}
                        timeout={timeoutStart}
                        duration={fxDuration / 1000}
                    />
                );
            } else if (stars > starIndex) {
                starItem = (
                    <StarFull
                        key={`star_${starIndex}`}
                        fx={fx}
                        timeout={timeoutStart}
                        duration={fxDuration / 1000}
                    />
                );
            } else {
                starItem = <StarEmpty key={`star_${starIndex}`} />;
            }
            starItems.push(
                className ? (
                    <div className={className} key={`star_item_${starIndex}`}>
                        {starItem}
                    </div>
                ) : (
                    starItem
                ),
            );
            starIndex++;
            timeoutStart = timeoutStart + fxDuration;
        }
        return starItems;
    };

    return <Fragment>{getCollectionStars(stars)}</Fragment>;
};
